import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const donwloadFileSlice = createSlice({
    name: 'donwloadFile',
    initialState: false,
    reducers: {
        setDownLoad: (state, action) => {
            return action.payload
        }
    }
})

export const donwloadFileThunk = (filename) => dispatch => {
    axios.get(`${API_BASE_URL}/download/${filename}`)
        .then(response => {
            if (response.ok) {
                return response.blob();
            }
            throw new Error('Error al descargar el archivo.');
        })
        .then(blob => {
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
        })
        .catch(error => {
            console.log('Error:', error);
        });
};

export const downloadContrato = async (contract_name, contratoId) => {
    try {
        const res = await axios.get(`/downloads/${contratoId}/download`, {
            responseType: 'blob',
        });

        const blob = res.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = contract_name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        alert('No se pudo descargar el contrato');
    }
};

export const downloadArchivosAdjuntos = async (archive, student, file) => {
    try {
        const res = await axios.put(`/downloads/download/adjuntos`, file, {
            responseType: 'blob',
        });

        const blob = res.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${archive+'_'+student.nombre+'_'+student.apellido+'.pdf'}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        alert('No se pudo descargar el contrato');
    }
};

export const downloadDocument = async (contract_name, contratoId) => {
    try {
        const res = await axios.get(`/downloads/${contratoId}/document`, {
            responseType: 'blob',
        });

        const blob = res.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = contract_name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        alert('No se pudo descargar el contrato');
    }
};

export const downloadForm = async (contract_name, contratoId) => {
    try {
        const res = await axios.get(`/downloads/${contratoId}/form`, {
            responseType: 'blob',
        });

        const blob = res.data;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = contract_name;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        alert('No se pudo descargar el contrato');
    }
};

export const { setDownLoad } = donwloadFileSlice.actions;

export default donwloadFileSlice.reducer;
